export default __webpack_public_path__ + "static/media/016.47df360f.jpg";